var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
export var MediaController = {
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/media/file" and http method "POST" to call the back-end.
    
        * @param {MediaInfo} mediaInfo
        * @returns {LinkDto}
    ******************************************************************************************************/
    GetByContainerAndName: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/media/file", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.mediaInfo
        });
    },
    /*****************************************************************************************************
        * Is using route "api/media/uploadFile" and http method "POST" to call the back-end.
    
        * @param {string} container
        * @param {string} fileName
        * @param {string} mediaType
        * @param {File} bytes
        * @returns {ContentMediaUploadDto}
    ******************************************************************************************************/
    UploadFile: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("container", JSON.stringify(data.container));
        fd.append("fileName", JSON.stringify(data.fileName));
        fd.append("mediaType", JSON.stringify(data.mediaType));
        if (data.bytes)
            fd.append("bytes", data.bytes);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/media/uploadFile", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/media/getUploadUrl" and http method "POST" to call the back-end.
    
        * @param {string} mediaType
        * @param {string} fileName
        * @returns {UploadMediaParametersDto}
    ******************************************************************************************************/
    GetUploadUri: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.mediaType !== undefined)
            fd.append("mediaType", JSON.stringify(data.mediaType));
        if (data.fileName !== undefined)
            fd.append("fileName", JSON.stringify(data.fileName));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/media/getUploadUrl", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/media/getUploadUrlWithContainer" and http method "POST" to call the back-end.
    
        * @param {string} mediaType
        * @param {string} fileName
        * @param {string} container
        * @returns {UploadMediaParametersDto}
    ******************************************************************************************************/
    GetUploadUriWithContainer: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.mediaType !== undefined)
            fd.append("mediaType", JSON.stringify(data.mediaType));
        if (data.fileName !== undefined)
            fd.append("fileName", JSON.stringify(data.fileName));
        if (data.container !== undefined)
            fd.append("container", JSON.stringify(data.container));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/media/getUploadUrlWithContainer", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/media/getUploadUrl/import" and http method "POST" to call the back-end.
    
        * @param {string} mediaType
        * @param {string} fileName
        * @returns {UploadMediaParametersDto}
    ******************************************************************************************************/
    GetUploadUriForImport: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.mediaType !== undefined)
            fd.append("mediaType", JSON.stringify(data.mediaType));
        if (data.fileName !== undefined)
            fd.append("fileName", JSON.stringify(data.fileName));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/media/getUploadUrl/import", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/media/file/json" and http method "POST" to call the back-end.
    
        * @param {MediaInfo} mediaInfo
        * @returns {any}
    ******************************************************************************************************/
    GetByContainerAndNameJson: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/media/file/json", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.mediaInfo
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/media/file/json/public" and http method "POST" to call the back-end.
    
        * @param {MediaInfo} mediaInfo
        * @returns {any}
    ******************************************************************************************************/
    GetByContainerAndNameJsonPublic: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/media/file/json/public", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.mediaInfo
        });
    },
    /*****************************************************************************************************
        * Is using route "api/media/file/json" and http method "PUT" to call the back-end.
    
        * @param {string} container
        * @param {any} data
        * @returns {LinkDto}
    ******************************************************************************************************/
    PutByContainerAndNameJson: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("container", JSON.stringify(data.container));
        fd.append("data", JSON.stringify(data.data));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/media/file/json", __assign({}, data)),
            method: "PUT",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/media" and http method "GET" to call the back-end.
    
        * @returns {MediaDownloadDto[]}
    ******************************************************************************************************/
    Get: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/media", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/media/qrCode/{content}" and http method "GET" to call the back-end.
    
        * @param {string} content
        * @returns {void}
    ******************************************************************************************************/
    GetQrCode: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/media/qrCode/{content}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/media/mail/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {MailTemplateDownloadDto}
    ******************************************************************************************************/
    GetMailTemplate: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/media/mail/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/media/mail" and http method "POST" to call the back-end.
    
        * @param {string[]} ids
        * @returns {MailTemplateDownloadDto[]}
    ******************************************************************************************************/
    GetMailTemplatesByIds: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("ids", JSON.stringify(data.ids));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/media/mail", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/media/mail/group/{groupId}" and http method "GET" to call the back-end.
    
        * @param {string} groupId
        * @returns {ExtendedDataCollection<MailTemplateDownloadDto, string>}
    ******************************************************************************************************/
    GetMailTemplates: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/media/mail/group/{groupId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/media/mail/by/ids" and http method "POST" to call the back-end.
    
        * @param {MailTemplateUploadDto} mail
        * @returns {MailTemplateDownloadDto}
    ******************************************************************************************************/
    AddMailTemplate: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("mail", JSON.stringify(data.mail));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/media/mail/by/ids", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/media/mail/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {MailTemplateUploadDto} mail
        * @returns {MailTemplateDownloadDto}
    ******************************************************************************************************/
    ChangeMailTemplate: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("mail", JSON.stringify(data.mail));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/media/mail/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/media/mail/{id}" and http method "DELETE" to call the back-end.
    
        * @param {string} id
        * @returns {void}
    ******************************************************************************************************/
    DeleteMailTemplate: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/media/mail/{id}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/media/mail/use/{id}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @returns {void}
    ******************************************************************************************************/
    UseMailTemplate: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/media/mail/use/{id}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/media/mail/unuse/{id}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @returns {void}
    ******************************************************************************************************/
    UnUseMailTemplate: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/media/mail/unuse/{id}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
};
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=MediaController.js.map